<template>
  <v-card
    class="pa-0 ma-0 card-hover cursor-pointer"
    outlined
    :class="small ? 'py-6' : 'py-8'"
    :height="small ? '170px' : '232px'"
    :width="small ? '136px' : '168px'"
    @click="$emit('click')"
  >
    <div class="border" />
    <v-card-text class="pa-0 ma-0">
      <div class="d-flex justify-center pa-0 mb-3">
        <UserAvatar
          data-private
          :account="account"
          :size="small ? '64px' : '108px'"
          :fontSize="small ? '20px' : '35px'"
        />
      </div>

      <div class="px-6">
        <div class="d-flex justify-left">
          <text-highlight
            data-testid="directory-text-userCardName"
            highlightClass="yellow lighten-1"
            data-private
            class="subtitle-2 font-weight-bold blue-grey--text text--darken-3 text-truncate"
            :queries="highlightTerm"
            >{{ name }}</text-highlight
          >
        </div>

        <div class="d-flex align-center mt-1">
          <text-highlight
            data-testid="directory-text-userCardPosition"
            data-private
            v-if="account.position"
            highlightClass="yellow lighten-1"
            class="caption ma-0 pa-0 text-truncate me-1"
            highlightComponent="span"
            :queries="highlightTerm"
            >{{ account.position }}</text-highlight
          >
          <div v-if="showHelper" class="d-flex justify-end align-center">
            <v-tooltip max-width="250px" top>
              <template v-slot:activator="{ on }">
                <v-icon color="blue-grey" size="16px" v-on="on"
                  >mdi-alert-circle-outline
                </v-icon>
              </template>

              {{ $t('common.users.result_based_on_matches_by_fields') }}
              <br />
              <li v-for="field in matchingFields" :key="field">
                {{ $t(`common.users.fields.${field}`) }}
              </li>
            </v-tooltip>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import userMixin from '@/mixins/userMixin.vue'

import UserAvatar from '@/components/UserAvatar.vue'

export default {
  name: 'UserCard',

  mixins: [userMixin],

  components: {
    UserAvatar,
  },

  props: {
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    matchingFields: {
      type: Array,
      required: false,
      default() {
        return []
      },
    },
    account: {
      type: Object,
      required: true,
    },
    highlightTerm: { type: String, required: false, default: '' },
  },

  computed: {
    name() {
      return this.account.nickname || this.getFullName(this.account)
    },

    showHelper() {
      if (!this.matchingFields.length) return false

      const highlightFields = this.shownFields.filter(field => {
        return this.matchingFields.includes(field)
      })

      return !highlightFields.length
    },

    shownName() {
      if (this.account.nickname) return ['nickname']

      return ['displayname', 'familyname']
    },

    shownFields() {
      return [...this.shownName, 'position']
    },
  },
}
</script>
